module.exports = __webpack_public_path__ + "img/gb-wls.94904119.svg";